import { useFormikContext } from "formik";
import { useState } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { IBusiness } from "@/business/business";
import { downloadQRCode } from "@/core/utils/download-qr";
import { formatPhoneNumber } from "@/core/utils/phone";
import BusinessInfoPair from "./business-info-pair";

const BusinessSummary = ({ business }: { business: IBusiness }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { values } = useFormikContext<Partial<IBusiness>>();

  const handleQRCodeDownload = () => {
    if (business?.qr_code_url) {
      void downloadQRCode(business.qr_code_url);
    }
  };

  return (
    <Stack className="w-full" align="start" gap={6} direction="row">
      <Stack align="start" gap={6} className="w-full min-w-0">
        <BusinessInfoPair label="Business name" value={values?.name} />
        <Stack
          align="start"
          direction="row"
          gap={6}
          className="w-full flex-wrap"
        >
          <BusinessInfoPair
            label="Phone (for referrals)"
            value={formatPhoneNumber(values?.phone_number || "", {
              withCountryCode: true,
            })}
          />
        </Stack>
      </Stack>
      {business?.qr_code_url && (
        <button
          type="button"
          aria-label="Download QR code"
          className="relative shrink-0 cursor-pointer rounded-lg outline-none focus-visible:ring-3 focus-visible:ring-focus/50"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onFocus={() => setIsHovered(true)}
          onBlur={() => setIsHovered(false)}
          onClick={handleQRCodeDownload}
        >
          <img
            src={business?.qr_code_url}
            alt="QR code"
            className={`w-[160px] ${isHovered ? "blur-xs" : ""}`}
          />
          {isHovered && (
            <div className="absolute inset-0 flex items-center justify-center">
              <Text weight="semibold" variant="caption">
                Download QR code
              </Text>
            </div>
          )}
        </button>
      )}
    </Stack>
  );
};

export default BusinessSummary;
